export default "__VITE_ASSET__C6Jk4haw__"